<template>
    <div class="auction-wrap col">
        <div
            v-if="auction.has_winner"
            :class="{has_winner : auction.has_winner}"
        >
            <p>{{ $trans('storefront::auction.card.done')}}</p>
        </div>
        <AuctionCard :auction="auction"/>
    </div>
</template>

<script>
    import AuctionCard from './../../AuctionCard.vue';

    export default {
        components: { AuctionCard },

        props: ['auction'],
    };
</script>
